<div class="how-it-works-section"
     [class.hiw-front-page]="!modalMode"
     [class.hiw-modal-mode]="modalMode">
  <div class="hiw-item hiw-find">
    <div class="hiw-img"
         [class.cursor-pointer]="isCursorPointer">
      <img src="/assets/img/how-it-works/find.png"
           [alt]="('howItWorksComponent.findPlace.title' | translate) + ' | Cake it easy'">
    </div>
    <div class="fw-bold" [innerHTML]="'howItWorksComponent.findPlace.title' | translate"></div>
    <div class="font-md mt-1" *ngIf="modalMode"
         [innerHTML]="'howItWorksComponent.findPlace.subTitle' | translate"></div>
  </div>

  <div class="hiw-arrow"></div>

  <div class="hiw-item hiw-choose">
    <div class="hiw-img"
         [class.cursor-pointer]="isCursorPointer">
      <img src="/assets/img/how-it-works/choose.png"
           [alt]="('howItWorksComponent.chooseCake.title' | translate) + ' | Cake it easy'">
    </div>
    <div class="fw-bold" [innerHTML]="'howItWorksComponent.chooseCake.title' | translate"></div>
    <div class="font-md mt-1" *ngIf="modalMode"
         [innerHTML]="'howItWorksComponent.chooseCake.subTitle' | translate"></div>
  </div>

  <div class="hiw-arrow"></div>

  <div class="hiw-item hiw-build">
    <div class="hiw-img"
         [class.cursor-pointer]="isCursorPointer">
      <img src="/assets/img/how-it-works/build.png"
           [alt]="('howItWorksComponent.buildCake.title' | translate) + ' | Cake it easy'">
    </div>
    <div class="fw-bold" [innerHTML]="'howItWorksComponent.buildCake.title' | translate"></div>
    <div class="font-md mt-1" *ngIf="modalMode"
         [innerHTML]="'howItWorksComponent.buildCake.subTitle' | translate"></div>
  </div>

  <div class="hiw-arrow"></div>

  <div class="hiw-item hiw-delivery">
    <div class="hiw-img"
         [class.cursor-pointer]="isCursorPointer">
      <img src="/assets/img/how-it-works/delivery.png"
           [alt]="('howItWorksComponent.delivery.title' | translate) + ' | Cake it easy'">
    </div>
    <div class="fw-bold" [innerHTML]="'howItWorksComponent.delivery.title' | translate"></div>
    <div class="font-md mt-1" *ngIf="modalMode"
         [innerHTML]="'howItWorksComponent.delivery.subTitle' | translate"></div>
  </div>
</div>
